var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83334 2.662C1.83456 2.48692 1.90461 2.31934 2.02835 2.19548C2.15209 2.07161 2.3196 2.0014 2.49468 2H14.5053C14.8707 2 15.1667 2.29667 15.1667 2.662V13.338C15.1655 13.5131 15.0954 13.6807 14.9717 13.8045C14.8479 13.9284 14.6804 13.9986 14.5053 14H2.49468C2.31922 13.9998 2.15101 13.93 2.027 13.8059C1.903 13.6817 1.83334 13.5135 1.83334 13.338V2.662ZM3.16668 3.33333V12.6667H13.8333V3.33333H3.16668ZM7.58134 5.61L10.834 7.778C10.8706 7.80234 10.9006 7.83535 10.9213 7.87408C10.9421 7.91281 10.9529 7.95606 10.9529 8C10.9529 8.04394 10.9421 8.08719 10.9213 8.12592C10.9006 8.16465 10.8706 8.19766 10.834 8.222L7.58068 10.39C7.54056 10.4166 7.494 10.4318 7.44592 10.4341C7.39785 10.4364 7.35006 10.4256 7.30762 10.4029C7.26517 10.3802 7.22966 10.3465 7.20485 10.3052C7.18004 10.264 7.16685 10.2168 7.16668 10.1687V5.83133C7.16677 5.7831 7.17994 5.73579 7.20478 5.69445C7.22963 5.65311 7.26522 5.61929 7.30777 5.59657C7.35033 5.57386 7.39824 5.56312 7.44641 5.56548C7.49459 5.56784 7.54122 5.58323 7.58134 5.61Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlay);
export default __webpack_public_path__ + "static/media/ic-play.a38cd00965c46f480c485481c99944fd.svg";
export { ForwardRef as ReactComponent };